export enum WalletPassState {
  ERROR,
  LOADING,
  SUCCESS,
  DEFAULT,
}
